<template>
  <div>
    <div class="notification is-primary">
      <i class="fa fa-thumbs-up"></i>
      {{ I18n.primer_mes_bonificado }}
    </div>

    <div class="field">
      <label for="tienda_nombre_fantasia" class="label">{{ I18n.nombre_fantasia }}:</label>
      <div class="control">
        <input
          v-model="tienda.nombre_fantasia"
          @change="nombreFantasiaDirty = true"
          :class="{ 'is-danger': nombreFantasiaDirty && !nombreFantasiaValido }"
          ref="nombreFantasia"
          id="tienda_nombre_fantasia"
          class="input"
          type="text"
          maxlength="50"
        />
      </div>
    </div>

    <div class="field">
      <label for="tienda_email" class="label">Email:</label>
      <div class="control">
        <input
          v-model="tienda.email"
          @change="emailDirty = true"
          :class="{ 'is-danger': emailDirty && !emailValido }"
          id="tienda_email"
          class="input"
          type="email"
          maxlength="75"
        />
      </div>
    </div>

    <div class="field">
      <label for="tienda_password" class="label">{{ I18n.password }}:</label>
      <div class="control">
        <input
          v-model="tienda.password"
          @change="passwordDirty = true"
          :class="{ 'is-danger': passwordDirty && !passwordValido }"
          id="tienda_password"
          class="input"
          type="password"
        />
      </div>
      <p class="help">
        {{ I18n.password_ayuda }}
      </p>
    </div>

    <div class="field">
      <label for="tienda_password_confirmation" class="label">{{ I18n.password_confirma }}:</label>
      <div class="control">
        <input
          v-model="tienda.password_confirmation"
          @change="passwordConfirmationDirty = true"
          :class="{ 'is-danger': passwordConfirmationDirty && !passwordConfirmationValido }"
          id="tienda_password_confirmation"
          class="input"
          type="password"
        />
      </div>
      <p v-if="passwordConfirmationDirty && !passwordConfirmationValido" class="help is-danger">
        {{ I18n.password_diferentes }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tienda: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      nombreFantasiaDirty: false,
      emailDirty: false,
      passwordDirty: false,
      passwordConfirmationDirty: false,
      I18n: serverExports.I18n
    }
  },

  created() {
    this.$emit('updateValida', this.valida)
  },

  mounted() {
    this.$refs.nombreFantasia.focus()
  },

  computed: {
    nombreFantasiaValido() {
      return this.tienda.nombre_fantasia.length
    },

    emailValido() {
      return /[a-z0-9_\.]+@[a-z\d\-]+(\.[a-z\d\-]+)*\.[a-z]+/.test(this.tienda.email)
    },

    passwordValido() {
      return this.tienda.password.length >= 6
    },

    passwordConfirmationValido() {
      return this.tienda.password == this.tienda.password_confirmation
    },

    valida() {
      return (
        this.nombreFantasiaValido &&
        this.emailValido &&
        this.passwordValido &&
        this.passwordConfirmationValido
      )
    }
  },

  watch: {
    valida(newValue) {
      this.$emit('updateValida', newValue)
    }
  }
}
</script>

<style scoped lang="scss">
.notification {
  font-size: 0.9rem;
  text-align: center;
  padding: 1rem;
  border-radius: 6px;

  i.fa {
    margin-right: 0.3rem;
  }
}
</style>
